import { env } from './env'

export const AUTH0_NAMESPACE = env.VITE_AUTH0_NAMESPACE as `https://${string}/`
export const AUTH0_DOMAIN = env.VITE_AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = env.VITE_AUTH0_CLIENT_ID
export const AUTH0_AUDIENCE = env.VITE_AUTH0_AUDIENCE

export const ROLE_CLAIM_KEY = `${AUTH0_NAMESPACE}role` as const
export const CUSTOMER_CLAIM_KEY = `${AUTH0_NAMESPACE}customer` as const

export type Auth0Role = 'app' | 'app_admin'
